import { render } from "./English.vue?vue&type=template&id=3fe2c542&ts=true"
import script from "./English.vue?vue&type=script&lang=ts"
export * from "./English.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__